export default __webpack_public_path__ + "static/media/undraw_empty.bb365899.svg";